// extracted by mini-css-extract-plugin
export default {"wrapper":"taskInformation_wrapper__XYWIe"};